export default __webpack_public_path__ + "static/media/5back.7089c01f.png";